
interface Location {
  id: string;
  name: string;
  city: string;
  description: string;
  acreditacion?: string;
  address: string;
  phone: string;
  email: string;
  hours: string;
  coordinates: [number, number]; // [lat, lng]
}

// Coordenadas de ejemplo - Por favor proporciona las coordenadas reales
export const locations: Location[] = [
  {
    id: 'cdmx',
    name: 'Ciudad de México (CDMX)',
    city: 'Ciudad de México',
    description: 'Ingeniería especializada para proyectos de alta exigencia en la principal zona metropolitana del país.',
    acreditacion:'Nuestro laboratorio está acreditado ante la EMA',
    address: 'Cda. Morelos 6, San Antonio Tecomitl, C.P. 12100, Milpa Alta, CDMX.',
    phone: '+52 (55) 2161-4772',
    email: 'contacto@liec.com.mx',
    hours: 'Lun - Vie: 9:00 - 18:00 hrs',
    coordinates: [19.4326, -99.1332]
  },
  {
    id: 'tepotzotlan',
    name: 'Tepotzotlán',
    city: 'Tepotzotlán',
    description: 'Ubicación estratégica dentro del corredor industrial más importante de México, brindando soporte técnico eficiente a proyectos industriales y logísticos.',
    address: 'Calle Mora #23, esquina con Quetzalcóatl, Pblo. San Mateo Xoloc, C. P. 54600, Tepotzotlán, Estado de México.',
    phone: '+52 (55) 5124-3350',
    email: 'jlopez@liec.com.mx',
    hours: 'Lun - Vie: 9:00 - 18:00 hrs',
    coordinates: [19.7167, -99.2167]
  },
  {
    id: 'san-luis-potosi',
    name: 'San Luis Potosí (SLP)',
    city: 'San Luis Potosí',
    description: 'Soporte técnico confiable en el corazón industrial del Bajío.',
    acreditacion:'Nuestro laboratorio está acreditado ante la EMA',
    address: 'Homero 455 (Bodega 6), El Aguaje, 78398, San Luis Potosí, SLP.',
    phone: '+52 (44) 4802-2172',
    email: 'achagre@liec.com.mx',
    hours: 'Lun - Vie: 9:00 - 18:00 hrs',
    coordinates: [22.1565, -100.9855]
  },
  {
    id: 'merida',
    name: 'Mérida',
    city: 'Mérida',
    description: 'Solidez y respaldo técnico para el desarrollo del sureste mexicano.',
    acreditacion:'Nuestro laboratorio está acreditado ante la EMA',
    address: 'Calle 50, entre C. 25 y C. 21, Plaza Padrón Local 1, Zona Dorada II. C. P. 97229, Mérida, Yucatán.  ',
    phone: '+52 (99)  9948-6356',
    email: 'lgarcia@liec.com.mx ',
    hours: 'Lun - Vie: 9:00 - 18:00 hrs',
    coordinates: [20.9674, -89.5926]
  },
  {
    id: 'lerma',
    name: 'Lerma',
    city: 'Lerma',
    description: 'Precisión técnica que impulsa el desarrollo del Valle.',
    acreditacion:'Sucursal acreditada ante la EMA (Entidad Mexicana de Acreditación).',
    address: 'Primera Cda. de la Merced, No. Ext. 6, El Calvario, C.P. 52006, Lerma, Estado de México.',
    phone: '+52 (728) 688-3216',
    email: 'vmartinez@liec.com.mx',
    hours: 'Lun - Vie: 9:00 - 18:00 hrs',
    coordinates: [19.2833, -99.5167]
  },
    {
    id: 'monterrey',
    name: 'Monterrey',
    city: 'Monterrey',
    description: 'Soluciones de ingeniería alineadas a los más altos estándares del polo industrial del norte del país.',
    address: 'C. Capitan Diego Rodríguez 2020, Arturo B. de La Garza, 64730 Monterrey, N.L.',
    phone: '+52 (81) 4305-5821',
    email: 'vgonzalez@liec.com.mx',
    hours: 'Lun - Vie: 9:00 - 18:00 hrs',
    coordinates: [19.2833, -99.5167]
  },
  {
    id: 'tapachula',
    name: 'Tapachula',
    city: 'Tapachula',
    description: 'Calidad y adaptabilidad para proyectos en entornos y terrenos desafiantes.',
    acreditacion:'Nuestro laboratorio está acreditado ante la EMA',
    address: 'Priv. Tulipanes Pte. Lote 36, mz 20, Frac. Tulipanes, C. P. 30797. Tapachula, Chiapas.',
    phone: '+52 (96) 2688-8924',
    email: 'ccampos@liec.com.mx ',
    hours: 'Lun - Vie: 9:00 - 18:00 hrs',
    coordinates: [19.2833, -99.5167]
  }
];
